import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {AgentReportGrid} from "./grid";
import {submitAgentReport} from "../../../services/report/agent";
import SelectInput from "../../system/select";
import {
  getPersonsNameAndFamilyByRole,
  getPersonsNationalCode,
  getPersonsPhoneByRole
} from "../../../services/profile/profile";
import Dict from "../../../helper/dict";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import {getProvinces} from "../../../services/province/province";
import FromToDateField from "../../system/fromToDateField";
import {downloadFile} from "../../../config";
import {PaginateContext} from "../../../context/paginate";

export function AgentReportManagement() {

  const [agentReport, setAgentReport] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  const [personId, setPersonId] = useState(null);
  const [phone, setPhone] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [nationalCode, setNationalCode] = useState(null);
  const [status, setStatus] = useState("accepted");
  const [firstLoginFrom, setFirstLoginFrom] = useState("")
  const [firstLoginTo, setFirstLoginTo] = useState("")
  const [lastLoginFrom, setLastLoginFrom] = useState("")
  const [lastLoginTo, setLastLoginTo] = useState("")

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(data, paginate) {
    const result = await submitAgentReport(data, paginate);
    if (result.status === 200) {
      const {agent_report, total_count} = result.data;
      setAgentReport(agent_report || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const data = {}
    if (personId) {
      data.person_id = personId;
    }

    if (phone) {
      data.phone = phone;
    }

    if (provinceId) {
      data.province_id = provinceId;
    }

    if (nationalCode) {
      data.national_code = nationalCode;
    }

    if (status) {
      data.status = status;
    }

    if (firstLoginFrom) {
      data.first_login_from = firstLoginFrom;
    }

    if (firstLoginTo) {
      data.first_login_to = firstLoginTo;
    }

    if (lastLoginFrom) {
      data.last_login_from = lastLoginFrom;
    }

    if (lastLoginTo) {
      data.last_login_to = lastLoginTo;
    }

    return data
  };

  useEffect(() => {
    const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(data, paginate)
  }, [personId, provinceId, nationalCode, status, firstLoginFrom, lastLoginFrom, firstLoginTo, lastLoginTo, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="w-full">
        <Card className="pt-8 w-full">
          <CardHeader floated={true} shadow={false} className="rounded-none w-full">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">مباشران</Typography>
            </div>

          </CardHeader>
          <CardBody className="overflow-x-auto w-full">

            <div className="grid grid-cols-1 gap-4 mb-2 md:grid-cols-3 xxl:grid-cols-3">

              <div className="flex flex-col">
                <SelectInput
                  label={"نام"}
                  defaultValue={personId}
                  refreshSignal={personId}
                  // multiselect={false}
                  autoLoadService={getPersonsNameAndFamilyByRole}
                  autoLoadServiceData="2"
                  autoLoadRender={({name, family, phone}) => {
                    const fullName = `${name?.trim()} ${family?.trim()}`.trim();
                    return fullName + " - " + phone
                  }}
                  onChange={setPersonId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("phone")}
                  defaultValue={personId}
                  refreshSignal={personId}
                  autoLoadService={getPersonsPhoneByRole}
                  autoLoadServiceData="2"
                  autoLoadRender={({phone}) => {
                    return persianNumberFormat(phone)
                  }}
                  onChange={setPersonId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("national_code")}
                  defaultValue={personId}
                  refreshSignal={personId}
                  autoLoadService={getPersonsNationalCode}
                  autoLoadRender={({national_code}) => {
                    return national_code
                  }}
                  onChange={setPersonId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("province")}
                  defaultValue={provinceId}
                  autoLoadService={getProvinces}
                  autoLoadRender={({title}) => {
                    return title
                  }}
                  onChange={setProvinceId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("status")}
                  defaultValue={status}
                  refreshSignal={status}
                  options={[
                    {
                      "id": "new",
                      "title": "جدید",
                    },
                    {
                      "id": "accepted",
                      "title": "تایید شده",
                    },
                    {
                      "id": "rejected",
                      "title": "رد شده",
                    },
                  ]}
                  onChange={setStatus}
                />
              </div>


            </div>

            <div className="grid grid-cols-1 gap-1 mb-2 md:grid-cols-2 xxl:grid-cols-2">
              <FromToDateField
                label="ثبت نام"
                fromDate={firstLoginFrom}
                setFromDate={setFirstLoginFrom}
                toDate={firstLoginTo}
                setToDate={setFirstLoginTo}
              />

              <FromToDateField
                label="آخرین ورود"
                fromDate={lastLoginFrom}
                setFromDate={setLastLoginFrom}
                toDate={lastLoginTo}
                setToDate={setLastLoginTo}
              />
            </div>

            <div className="flex flex-row justify-between">
              <Button variant="gradient" color="gray" onClick={() => {
                setPersonId(null)
                setProvinceId(null)
                setNationalCode(null)
                setStatus("accepted")
                setFirstLoginFrom("")
                setFirstLoginTo("")
                setLastLoginFrom("")
                setLastLoginTo("")
              }} className="ml-1">
                <span>حذف فیلتر</span>
              </Button>

              {agentReport.length > 0 &&
                <Button size="sm" variant="outlined" onClick={() => {
                  const data = filter();
                  downloadFile("agent_report_excel", data, "agents")
                }}>
                  خروجی اکسل
                </Button>
              }
            </div>

            <AgentReportGrid
              userReport={agentReport}
            />
          </CardBody>
          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  )
    ;
}
